import React from "react"
import { Container, Flex, Heading, Image } from "@theme-ui/components"
import { InboundLink } from "./link"
import { getLandscapePath } from "../utils/path"
import { i18nContext } from "../context/i18nContext"
import ArrowRight from "../images/arrow-right.svg"

const MobileBanner = ({ data }) => {
  return (
    <i18nContext.Consumer>
      {t => (
        <Container
          sx={{
            bottom: 0,
            zIndex: 4,
            backgroundColor: "primary",
            paddingY: [0, 0, 0, 0],
            height: "50px",
          }}
          variant="fw"
        >
          <Flex
            sx={{
              justifyContent: "space-between",
              alignItems: "center",
              alignContent: "center",
              height: "100%",
            }}
          >
            <Heading
              sx={{
                color: "light",
                textTransform: "uppercase",
                fontSize: [1, 2, 2, 4],
                mr: [4],
              }}
              as="h2"
            >
              {t.contact}
            </Heading>
            <Flex
              sx={{
                color: "light",
                fontWeight: 600,
                fontSize: [0, 2, 2, "21px"],
                a: {
                  color: "light",
                  display: "block",
                  textDecoration: "underline",
                  mr: [1],
                },
              }}
            >
              <Image src={ArrowRight} />
            </Flex>
          </Flex>
        </Container>
      )}
    </i18nContext.Consumer>
  )
}

export default MobileBanner
